// Attach the admin JWT to every axios call to our own API (calls that forgot the header
// would otherwise be rejected by permission-checked routes). Other hosts never get the token.
import axios from 'axios';
import { API_BASE_URL } from '../constants/constants';

const isOwnApi = (url = '') => {
  if (url.startsWith(API_BASE_URL)) return true;
  if (API_BASE_URL.startsWith('/') && url.startsWith('/')) return true;
  try {
    const target = new URL(url, window.location.origin);
    const api = new URL(API_BASE_URL, window.location.origin);
    return target.origin === api.origin && target.pathname.startsWith(api.pathname);
  } catch {
    return false;
  }
};

axios.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('token');
  const headers = config.headers || {};
  const hasAuth = typeof headers.get === 'function' ? !!headers.get('Authorization') : !!headers.Authorization;
  if (token && !hasAuth && isOwnApi(config.url)) {
    if (typeof headers.set === 'function') headers.set('Authorization', `Bearer ${token}`);
    else headers.Authorization = `Bearer ${token}`;
    config.headers = headers;
  }
  return config;
});
